import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <>
      <div>Pregame Social Home</div>
      <Link to="./delete-data">data deletion guide</Link>
      <br />
      <Link to="./privacy-policy">Privacy</Link>
      <br />
      <Link to="./terms-conditions">Terms and Conditions</Link>
    </>
  );
};

export default Home;
